import * as React from "react";
import { Input } from "antd";

interface IProps {
	prefix?: React.ReactNode;
	suffix?: React.ReactNode;
	id: string;
	name?: string;
	type?: string;
	placeholder?: string;
	value?: string | number;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onClick?: (e: any) => void;
	onKeyDown?: (e?: any) => void;
	onKeyPress?: (e?: any) => void;
	onKeyUp?: (value?: any) => void;
	onBlur?: (e?: any) => void;
	defaultValue?: string;
	className?: string;
	min?: number;
	step?: number;
	maxlength?: number;
	focus?: boolean;
}

const TextInputAnt: React.FC<IProps> = (props) => {
	return (
		<Input
			id={props.id!}
			onChange={props.onChange}
			name={props.name}
			type={props.type}
			value={props.value}
			className={props.className}
			placeholder={props.placeholder}
			autoFocus={props.focus}
		/>
	);
};

export default TextInputAnt;
